import React from 'react';

import { useTranslation } from '../../../../../../../hooks';
import { T } from '../../../../../../../constants';

interface LevelsTableHeaderProps {
  levels: Array<number>;
}

export const LevelsTableHeader: React.FC<LevelsTableHeaderProps> = ({ levels }) => {

  const t = useTranslation();

  return (
    <div className="free-drop-popup-table-header">
      <p className="free-drop-popup-table-header-txt dates">{ t(T.DROP_DATES) }</p>
      {
        levels.map((number) => (
          <p
            key={number}
            className="free-drop-popup-table-header-txt"
          >
            { t(T.LEVEL) } { number }
          </p>
        ))
      }
    </div>
  );
};
